<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>检查事项</el-breadcrumb-item>
                <!-- <el-breadcrumb-item>班组信息</el-breadcrumb-item> -->
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <p class="main-left-p">
                    <span>检查事项：{{folderList.length}}</span>
                    <el-button size="mini" type="text" @click="addEntFun" style="font-size:0.8vw;">添加</el-button>
                </p>
                <div class="main-left-list">
                    <ul>
                        <li v-for="(item,index) in folderList" :key="index" :class="{'curEnt':folderId==item.id}" @click="getEntId(item)">
                            <!-- <i class="el-icon-folder"></i> -->
                            <div class="unit-name color4">
                                <p :title="item.description" class="nowrap">{{item.description}}</p>
                            </div>
                            <div class="unit-ctl color4" style="width:40%;">
                                <el-button type="text" @click="editFolder(item)">编辑</el-button>
                                <el-button type="text" style="color:red;" @click="delFolder(item)">删除</el-button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="main-table">
                <div class="table-head">
                    <div class="table-head-seach">
                        <el-input placeholder="搜索检查内容" v-model="search.description" style="margin-right:1vw;"></el-input>
                        <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                    </div>
                    <div style="display: flex;align-items: center;">
                        <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addContent" style="margin-right:1vw;">添加</el-button>
                        <el-upload
                            class="upload-demo"
                            v-if="folderId!=''"
                            v-bind:action="uploadUrl"
                            :headers="uploadHead"
                            :data="uploadData"
                            :show-file-list="false"
                            :before-upload="filesBefore"
                            :on-success="fileSuccess">
                            <el-button type="primary" size="mini" plain icon="el-icon-download" style="margin-right:1vw;">导入</el-button>
                        </el-upload>
                        <el-button type="primary" size="mini" plain icon="el-icon-upload2" style="margin-right:1vw;" @click="exportFun">导出</el-button>
                    </div>
                </div>
                <div class="table-box">
                    <el-table :data="tableDataEnd" height="100%" style="width: 100%" :show-header="false" >
                        <template slot="empty">
                            <p>{{dataText}}</p>
                        </template>
                        <el-table-column label="" class-name="columt-col">
                            <template slot-scope="scope">
                                <span>{{ scope.row.description }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="240">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" @click="handleDown(scope.$index, scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
        :title="entTitle"
        :visible.sync="entVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="30%"
        >
            <el-form
                :model="addFolder"
                ref="addFolder"
                :rules="rules"
                label-width="200px"
                label-position="right"
                class="joinEnt"
            >
                <el-form-item label="项目类型：" prop="projectType">
                    <el-select v-model="addFolder.projectType" class="box-select" placeholder="请选择" style="width:220px">
                        <el-option v-for="(item,index) in proTypes" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="事项名称：" prop="description">
                    <el-input v-model="addFolder.description" autocomplete="off" style="width:220px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="entVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddFolder('addFolder')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 内容弹出框 -->
        <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <el-form
                :model="addVal"
                ref="addVal"
                :rules="codeRules"
                label-width="100px"
                label-position="right"
                class="joinEnt"
            >
                <el-form-item label="内容：" prop="description">
                    <el-input type="textarea" :rows="5" placeholder="请编辑检查内容" v-model="addVal.description"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="codeVis = false">取 消</el-button>
                <el-button type="primary" @click="sumbitVal('addVal')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 导入提示 -->
        <el-dialog
            title="提示"
            :visible.sync="tipVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            :close-on-click-modal="false"
        >
            <template>
            <el-table :data="tipList" style="width: 100%" border>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0">
                            <i class="el-icon-circle-check" style="color:#07C160"></i>
                        </span>
                        <span v-else>
                            <i class="el-icon-warning-outline" style="color:#f00"></i>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="原因">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0"  style="color:#07C160">{{scope.row.reason}}</span>
                        <span v-else style="color:#f00">{{scope.row.reason}}</span>
                    </template>
                </el-table-column>
            </el-table>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            search:{
                description:''
            },
            groupId:'',
            folderList:[],//检查事项list
            proTypes:[],//项目类型
            //事项弹出框
            entVisible:false,
            addFolder:{
                id:'',
                description:'',
                entId:'',
                projectType:'',
            },
            entTitle:'',
            rules: {
                description: [
                    { required: true, message: '请填写检查事项', trigger: 'blur' }
                ],
            },
            folderId:'',//当前展示文件夹id
            tableDataEnd:[],//班组列表
            diaTitle:'添加文件夹',//班组添加名称
            dataText: '数据加载中...',
            uploadUrl:myHttp.importProQsNapeExcel,//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            uploadData:{//上传参数
                parentId:'',
                entId:''
            },
            //二维码
            codeVis:false,
            codeTit:'添加检查内容',
            addVal:{
                id:'',
                description:'',
                parentId:'',
                entId:'',
            },
            codeRules:{
                description: [
                    { required: true, message: '请编辑检查内容', trigger: 'blur' }
                ],
            },
            //提示
            tipVis:false,
            tipList:[],
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.uploadData.entId = this.groupId
        this.getFolder()
        // this.getPerson()
        this.getProType()
    },
    methods:{
        //获取项目类型
        getProType(){
            var that = this
            myHttp.getDictByType({
                type:'project_type'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.dictList||[]
                    that.proTypes = list
                }
            })
        },
        //获取文件夹
        getFolder(){
            var that = this
            myHttp.selectProQsNapeList({
                parentId:0,
                entId:this.groupId,
            }).then(function(resp){
                if (resp.data.code == '200'){
                    var list = resp.data.data.proQsNapes || []
                    if(list.length>0){
                        that.folderId = list.length>0?list[0].id:''
                        that.uploadData.parentId = that.folderId
                        that.getData()
                    }else{
                        that.dataText = '暂无数据'
                    }
                    that.folderList = list
                }else{

                }
            })
        },
        //添加参建单位
        addEntFun(){
            this.entVisible = true
            this.addFolder.description = ''
            this.addFolder.id = ''
            this.addFolder.projectType = ''
            this.addFolder.entId = this.groupId
            this.entTitle = '添加检查事项'
            
        },
        
        //添加或者修改文件夹
        sumbitAddFolder(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.addFolder.id == '') {
                    myHttp.createProQsNape(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateProQsNape(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                  return false
                }
            })
        },
        //选择展示的文件夹
        getEntId(row){
            this.folderId = row.id
            this.uploadData.parentId = row.id
            this.getData()
        },

        /***
         * 获取文件
         */
        getData(){
            var that = this
            // console.log(this.joinEntId)
            myHttp.selectProQsNapeList({
                description:this.search.description,
                parentId:this.folderId,
                entId:this.groupId
            }).then(function(resp){
                if (resp.data.code == '200') {
                    var list = resp.data.data.proQsNapes || []
                    // for(var i=0;i<list.length;i++){
                    //     list[i].fileFormat = list[i].filesName && list[i].filesName!=''?that.getImg(list[i].filesName):'0'
                    // }
                    that.tableDataEnd = list
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                } else {
                    that.$message.error(resp.data.msg)
                    that.dataText = '暂无数据'
                }
            })
        },
        /**
         * 根据名称查询班组
         */
        doFilter(){
            // this.getTeam()
            this.getData()
        },

        //编辑文件夹
        editFolder(obj){
            this.entVisible = true
            this.addFolder.description = obj.description
            this.addFolder.projectType = obj.projectType
            this.addFolder.entId = this.groupId
            this.addFolder.id = obj.id
            this.entTitle = '修改检查事项'

        },
        //删除文件夹
        delFolder(obj){
            
            var that = this
            this.$confirm('此操作将永久删除该检查事项, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteProQsNapeLogic({
                    id: obj.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.getFolder()
                    } else {
                    that.$message.error(resp.data.msg)
                    }
                })
            })
        },

        /**
         * 添加内容
         */
        addContent(){
            this.codeVis = true
            this.codeTit = '添加检查内容'
            this.addVal.id  = ''
            this.addVal.description  = ''
            this.addVal.parentId  = this.folderId
            this.addVal.entId = this.groupId
        },
        /**
         * 编辑
         */
        handleDown(index,row){
            this.codeVis = true
            this.codeTit = '编辑检查内容'
            this.addVal.id  = row.id
            this.addVal.description  = row.description
            this.addVal.parentId  = row.folderId
            this.addVal.entId = this.groupId
        },
        /**
         * 提交内容
         */
        sumbitVal(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.addVal.id == '') {
                    myHttp.createProQsNape(this.addVal).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.codeVis = false
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateProQsNape(this.addVal).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.codeVis = false
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                  return false
                }
            })
        },
        /**
         * 导入之前
         */
        filesBefore(file){
            this.uploadData.parentId = this.folderId
        },
        /**
         * 导入返回
         */
        fileSuccess(res,file,opt){
            this.tipVis = true
            var list = res.data.resultMap||[]
            this.tipList = list
            this.getData()
        },
        /**
         * 导出
         */
        exportFun(){
            var token = util.session.get('token')
            window.open(myHttp.exportProQsNapeExcel+'?description='+this.search.description+'&parentId='+this.folderId+'&entId='+this.groupId+'&accessToken='+token)
        },
    }

}
</script>
<style scoped>
    
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        /* overflow: auto; */
        background: #fff;
        border-radius: 0.5vh;
    }
    .main-left-search{
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vh;
    }
    .main-left-p{
        width: 100%;
        height: 7%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content:space-between;
        padding: 0 1vh;
    }
    .main-left-list{
        width: 100%;
        height: 85%;
        position: relative;
        overflow: auto;
    }
    .main-left-list li{
        width: 100%;
        height: 5vh;
        position: relative;
        padding:1vh;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }
    .main-left-list li:hover{
        background: #eee;
    }
    .curEnt{
        background: #E7F1FB;
    }
    .curEnt i,.curEnt p{
        color: #5A87F9;
    }
    /* .unit-type{
        width: 20%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-items: center;
        align-content: center;
        border: 1px solid #0365F2;
        padding: 1.5%;
    } */
    .unit-name{
        width: 60%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        align-content: center;
        padding-left: 1vh;
        flex-wrap: wrap;
    }
    .unit-name p{
        width: 100%;
        text-align: left;
    }
    .main-table{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
    }
    .table-head{
        width: 100%;
        height: 6vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 0 1vw;
        justify-content: space-between;
        border-bottom: 5px solid #ecf0f5;
    }
    .table-head-seach{
        width: 50%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 6vh );
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
    }
    .box-ent{
        width: 100%;
        height: 10vh;
        position: relative;
        margin-bottom: 1vh;
        background: #fff;
        border-radius: 5px;
        display: flex;
        /* flex-wrap: wrap; */
    }
    .box-ent-l{
        width: 80%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 2vh;
        align-content: center;
        align-items: center;
    }
    .box-ent-l p{
        width: 33%;
        height: 3vh;
        position: relative;
        text-align: left;
        padding-right: 1vh;
    }
    .box-ent-r{
        width: 20%;
        height: 100%;
        display: flex;
        align-content: center;
        align-items: center;
    }
    
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
</style>
<style>
    @import '../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 5px solid #ecf0f5;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 5px solid #ecf0f5;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
    .main-table .el-table .columt-col .cell{
        text-align: left;
    }
</style>